var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tree',{attrs:{"auto-expand-parent":_vm.autoExpandParent,"tree-data":_vm.resolvePermissionList,"checkable":""},on:{"check":_vm.functionSelectCheck},model:{value:(_vm.functionSelect),callback:function ($$v) {_vm.functionSelect=$$v},expression:"functionSelect"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }